import MetisMenu from "metismenujs"
import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import { withTranslation } from "react-i18next"
import { Link, withRouter } from "react-router-dom"
import SimpleBar from "simplebar-react"

const SidebarContent = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag
        const parent3 = parent2.parentElement // li tag
        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t("Masters")}</li>
            <li><Link to="/settings/locations" className=" "><i className="fas fa-location-arrow"></i><span>{props.t("Location")}</span></Link></li>
            <li><Link to="/settings/canteens" className=" "><i className="fas fa-hot-tub"></i><span>{props.t("Canteens")}</span></Link></li>
            <li><Link to="/settings/panel-users" className=" "><i className="fas fa-users-cog"></i><span>{props.t("Panel Users")}</span></Link></li>
            
            <li className="menu-title">{props.t("Diner")}</li>
            <li><Link to="/temporary-employees" className=" "><i className="fas fa-user-plus"></i><span>{props.t("Temporary Employees")}</span></Link></li>
            <li><Link to="/employees" className=" "><i className="fas fa-user-plus"></i><span>{props.t("Employees")}</span></Link></li>
            <li><Link to="/guests" className=" "><i className="fas fa-user-tie"></i><span>{props.t("Guest")}</span></Link></li>
            
            <li className="menu-title">{props.t("Diner Reports")}</li>
            <li><Link to="/reports/token" className=" "><i className="far fa-circle"></i><span>{props.t("Token Reports")}</span></Link></li>
            <li><Link to="/reports/monthly" className=" "><i className="far fa-circle"></i><span>{props.t("Monthly")}</span></Link></li>
            {/* <li><Link to="/reports/employee" className=" "><i className="far fa-circle"></i><span>{props.t("Employee Reports")}</span></Link></li>
            <li><Link to="/reports/custom" className=" "><i className="far fa-circle"></i><span>{props.t("Date wise")}</span></Link></li> */}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
